import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from 'src/app/validators/email-validator';

import { InvitationContactForm } from './invitation-contact-form';

export class VendorInviteForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  CompanyComplianceTypeId: FormControl<number | undefined>;
  inviteCode: FormControl<string | undefined>;
  inviteEmail: FormControl<string | undefined>;
  inviteEmailListCode: FormControl<string | undefined>;
  referrer: FormControl<string | undefined>;
  isActive: FormControl<boolean>;
  InvitationContact: InvitationContactForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      CompanyComplianceTypeId: new FormControl<number | undefined>(undefined, {
        nonNullable: true
      }),
      inviteCode: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      inviteEmail: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required, emailValidator]
      }),
      inviteEmailListCode: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      referrer: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      isActive: new FormControl<boolean>(false, { nonNullable: true }),
      InvitationContact: new InvitationContactForm()
    });
  }
}
